





























































































































































































































import { Vue, Component } from 'vue-property-decorator'
import { IBaseRes } from '@/api/files/files-base/res'
import { getTagList, getTagCategory, addTag, deleteTag } from '@/api/files/files-base/filesBase'
import { Form } from 'element-ui'
import { resetObjValue2NoneString } from '@/utils/tool'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'
import { getChaos, getCookie, getImgURLOfBase64 } from '@/utils/fix'

const domain = 'http://pics.tutuapp.com/'

@Component({
  name: 'FilesBaseTag'
})
export default class extends mixins(DateOption) {
  // data
  private params = {
    id: '',
    name: '',
    category: '',
    updateDateStart: '',
    updateDateEnd: '',
    page: 1,
    pageCount: 20
  }
  private addParams = {
    id: 0,
    name: '',
    category: '',
    picPath: ''
  }
  private tableData: IBaseRes[] = []
  tableLoading = false
  private selectedData: IBaseRes[] = []
  private totalCount: number = 0
  private addFormVisible: boolean = false
  private dateArray: string[] = ['', '']
  private typeList: ISelectItem[] = []
  private rules: any = {
    name: [{ required: true, message: '请输入标签名', trigger: 'blur' }],
    category: [{ required: true, message: '请选择类别', trigger: 'change' }]
  }
  tableHeight: number = 500
  // lifecycle
  created() {
    this.getTableData()
    this.getTagCategory()
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
  }
  beforeDestroy() {
    window.removeEventListener('resize', this.setTableHeight)
  }
  // methods
  async getTableData() {
    this.tableLoading = true
    let res = await getTagList(this.params)
    let dataList = res.data.dataList || []
    let buildEnv = process.env.VUE_APP_ENV || ''
    if (buildEnv !== 'env') {
      this.tableData = dataList
      this.tableLoading = false
      this.totalCount = res.data.pageInfo.totalCount
      return false
    }
    this.tableData = []
    await getChaos()
    let header = {
      abc: getCookie('abc')
    }
    this.tableLoading = false
    const cover: string = require('@/assets/images/loading.svg')
    dataList.forEach((item: any) => {
      let el = { ...item }
      el.picPath = cover
      this.tableData.push(el)
    })
    this.totalCount = res.data.pageInfo.totalCount
    for (let i = 0; i < dataList.length; i++) {
      getImgURLOfBase64(dataList[i].picPath, header).then(res => {
        this.tableData[i]['picPath'] = res as string
      })
    }
    this.tableLoading = false
    this.totalCount = res.data.pageInfo.totalCount
  }
  async getTagCategory() {
    let res = await getTagCategory()
    this.typeList = res.data
  }
  async addTag() {
    let res: any = await addTag(Object.assign(this.addParams, {
      picPath: this.addParams.picPath.split(domain).pop() as string
    }))
    if (res.status.code === 0) {
      this['$message'].success('添加成功!')
      resetObjValue2NoneString(this.addParams, ['id'])
      this.addFormVisible = false
    } else {
      this['$message'].error('添加失败!')
    }
    this.getTableData()
  }
  setTableHeight() {
    const filter: any = this.$refs.filter
    const filterDom: any = filter.$el
    this.tableHeight = document.body.clientHeight - 250 - filterDom.clientHeight
  }
  deleteTag(id: string) {
    this.$confirm('确认删除该数据?', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async() => {
        let res: any = await deleteTag({ id })
        if (res.status.code === 0) {
          this['$message'].success('删除成功!')
          this.getTableData()
        } else {
          this['$message'].error('删除失败!')
        }
      })
      .catch(() => {})
  }
  handleDateChange(date: string[]) {
    this.params.updateDateStart = date && date[0]
    this.params.updateDateEnd = date && date[1]
  }
  handleSearch() {
    if (this.tableLoading) { return false }
    let params:any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  handleReset() {
    resetObjValue2NoneString(this.params, ['page', 'pageCount'])
    this.dateArray = ['', '']
    this.params.page = 1
  }
  handleSelectionChange(list: IBaseRes[]) {
    this.selectedData = list
  }
  handleSelectAll() {
    // 如果没有选择全部, 则寻找未选择的行, 并将这些行选中
    if (this.selectedData.length < this.tableData.length) {
      let tempSelectList = this.selectedData.map(item => item.id)
      let unSelected: any[] = this.tableData.filter((item: any) => !tempSelectList.includes(item.id))
      unSelected.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handleSelectReverse() {
    this.selectedData = []
    let tempList: number[] = []
    let tempSelectList: number[] = []
    let indexList: number[] = []
    tempList = this.tableData.map(item => item.id)
    tempSelectList = this.selectedData.map(item => item.id)
    indexList = tempList.filter(item => !tempSelectList.includes(item))
    this.tableData.forEach(item => {
      if (indexList.includes(item.id)) this.selectedData.push(item)
    })
    if (this.selectedData.length) {
      this.selectedData.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handleRemoveAll() {
    let t: number[] = []
    this.selectedData.forEach(item => {
      t.push(item.id)
    })
    let ids = t.join(',')
    this.deleteTag(ids)
  }
  handleExcel() {}
  editApp(item: IBaseRes) {
    this.addFormVisible = true
    this.addParams.name = item.name
    this.addParams.picPath = item.picPath
    this.addParams.id = item.id
    this.addParams.category = item.categoryId
  }
  removeApp(item: IBaseRes) {
    let id = item.id.toString()
    this.deleteTag(id)
  }
  handleAdd() {
    this.addFormVisible = true
    this.addParams.id = 0
  }
  cancelAddForm() {
    this.addFormVisible = false
  }
  confirmAddForm() {
    if (this.addParams.name.length <= 0) {
      return this.$message.warning('请输入角标名')
    }
    if (!this.addParams.category) {
      return this.$message.warning('请选择角标位置')
    }
    if (!this.addParams.picPath) {
      return this.$message.warning('请上传角标图片')
    }
    this.addTag()
  }
  handleFormClose() {
    this.addParams.name = ''
    this.addParams.category = ''
    this.addParams.picPath = ''
  }
  // computed
  get showMultiSelect() {
    return this.selectedData.length > 1
  }
  get selectCount() {
    return this.selectedData.length
  }
}
